import Link from 'next/link';
import styled, { css } from 'styled-components';

export type LogoVariant = 'default' | 'practitioners';
export type LogoSize = 'natural' | 'fixed';

const logoColor = ($light: boolean) => ($light ? 'var(--fill-bright)' : 'var(--fill-brand)');

const collapsedStyles = ($light: boolean) => css`
  font-size: 0;
  line-height: 0;
  width: 13px;
  height: 13px;
  background-color: ${logoColor($light)};
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  text-indent: -9999px;
`;

export const logoTextStyle = ($light: boolean) => css`
  font-family: 'Seed Sans';
  font-weight: 300;
  line-height: 1;
  color: ${logoColor($light)};
`;

export const StyledLink = styled(Link)<{
  $variant?: LogoVariant;
  $light: boolean;
  $expanded: boolean;
  $size: LogoSize;
  $fontSize?: string;
}>`
  && {
    letter-spacing: normal !important;
  }

  ${({ $light }) => logoTextStyle($light)};
  text-decoration: none;
  align-content: center;
  font-size: ${({ $fontSize }) => $fontSize || '22.76px'};
  z-index: 2;
  &:hover,
  &:focus {
    ${({ $light }) => logoTextStyle($light)};
  }

  ${({ $expanded, $light }) => !$expanded && collapsedStyles($light)};
  ${({ $variant }) => $variant === 'practitioners' && 'cursor: unset;'}

  ${({ $size }) =>
    $size === 'fixed' &&
    `
      height: 80px;
  `}
`;
